var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import classNames from 'clsx';
import ListItem, {} from './ListItem';
import { StyledList } from './styles/list.styled';
/**
 * The List component can be used to display a list of items
 */
const List = (_a) => {
    var { children, panel = false, items, class: className = '', iconSize = 'xxxl', iconColor, variant = 'basic', dataTest = 'list', colorTheme = 'dark', outsideSpacing = true } = _a, props = __rest(_a, ["children", "panel", "items", "class", "iconSize", "iconColor", "variant", "dataTest", "colorTheme", "outsideSpacing"]);
    const listClassNames = classNames('PONCHO-list', className, {
        'ANWB-panel__content': panel,
        [variant ? `PONCHO-list--${variant}` : '']: variant,
        [variant && iconSize ? `PONCHO-list--${variant}-size-${iconSize}` : '']: variant === 'icons',
    });
    if (children && Children.toArray(children).length > 0) {
        return (_jsx(StyledList, Object.assign({ as: variant === 'numbered' ? 'ol' : 'ul', className: listClassNames, "data-test": `${dataTest}-list-${variant === 'numbered' ? 'ordered' : 'unordered'}`, "$variant": variant, "$iconSize": iconSize, "$iconColor": iconColor, "$colorTheme": colorTheme, "$outsideSpacing": outsideSpacing }, props, { children: children })));
    }
    if (items && Children.toArray(items).length > 0) {
        return (_jsx(StyledList, Object.assign({ as: variant === 'numbered' ? 'ol' : 'ul', className: "PONCHO-list", "data-test": `${dataTest}-list-${variant === 'numbered' ? 'ordered' : 'unordered'}`, "$iconSize": iconSize, "$variant": variant, "$colorTheme": colorTheme, "$outsideSpacing": outsideSpacing }, props, { children: items.map((item, key) => (
            // eslint-disable-next-line react/no-array-index-key
            _jsx(ListItem, { variant: variant, iconColor: iconColor, dataTest: `${dataTest}-item`, children: item }, key))) })));
    }
    return null;
};
List.Item = ListItem;
export default List;
